import React from 'react';
import styles from './Buttons.module.css';
import LoaderButton from '../../Moecules/Loader/LoaderButton';

const Buttons = ({
  text,
  to,
  handleOnClick,
  icon,
  width,
  rounded,
  color,
  isLoading,
  disabled,
  className,
}) => {
  return !isLoading ? (
    <button
      onClick={handleOnClick}
      className={`${styles[rounded ? 'aud-button-rounded' : 'aud-button']} ${
        disabled ? styles['disabled-button'] : ''
      } ${className}`}
      style={{
        width: width,
        borderRadius: !text ? '50%' : rounded ? '25px' : '0px',
        backgroundColor: color ? color : '#1b224c',
      }}
      disabled={disabled}
    >
      {icon && (
        <img
          src={icon}
          alt='Icon'
          className={`${styles['button-icon']}`}
          style={{ paddingRight: !text && '0px' }}
        />
      )}
      {text ? text : null}
    </button>
  ) : (
    <LoaderButton />
  );
};

export default Buttons;
